var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rgpd-page", attrs: { id: "cms" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "cmsContent container" }, [
        _c("h1", { staticClass: "center-block" }, [_vm._v("Plan du site")]),
        _vm._v(" "),
        _vm.shop
          ? _c(
              "ul",
              [
                _c("li", [
                  _c("a", { attrs: { href: _vm.shop.ShopId } }, [
                    _vm._v("Accueil"),
                  ]),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c(
                    "li",
                    [
                      _c("sitemap-tree-item", {
                        attrs: { shop: _vm.shop, item: _vm.shop.productTree },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.visiblePages, function (page) {
                  return _c("li", { key: page.id }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          title: page.title,
                          href: _vm.shop.ShopId + "/page/" + page.id,
                        },
                      },
                      [_vm._v(_vm._s(page.title))]
                    ),
                  ])
                }),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        title: "Conditions générales de vente",
                        href: _vm.shop.ShopId + "/cgv",
                      },
                    },
                    [_vm._v("Conditions générales")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        title: "Confidentialité & cookies - RGPD",
                        href: _vm.shop.ShopId + "/rgpd",
                      },
                    },
                    [_vm._v("Confidentialité")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("a", { attrs: { href: _vm.shop.ShopId + "/contact" } }, [
                    _vm._v("Nous contacter"),
                  ]),
                ]),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }